import styled from 'styled-components';

export const ConfigureHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ConfigureIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const ConfigureTitle = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #212529;
`;

export const ConfigureDescription = styled.p`
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #6c757d;
`;

export const ChannelCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ChannelIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 4px;
`;

export const ChannelIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 40%;
  background: ${({ $bg }) => $bg};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 14px;
    height: 14px;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  padding: 15px;
`;

export const CheckboxWrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 10px;
  border: 0.4px solid #d4d8dd80;
  box-shadow: 0px 4px 4px 0px #1d355733;
  margin-top: 18px;
  margin-bottom: 15px;
`;

export const ChannelTable = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
`;

export const TableHeaderCell = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  text-align: center;

  &:first-child {
    text-align: left;
  }
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f3f5;
  align-items: center;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f8f9fa;
  }
`;

export const TableCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  &:first-child {
    justify-content: flex-start;
  }
`;
